import { HubConnection, HubConnectionBuilder, LogLevel, RetryContext } from "@microsoft/signalr";
import { clamp } from "lodash-es";

export interface CreateSignalrHubOptions {
	url: string;
	accessTokenFactory: () => Promise<string>;
}

export function createSignalrHub(options: CreateSignalrHubOptions): HubConnection {
	return new HubConnectionBuilder()
		.withUrl(options.url, {
			accessTokenFactory: options.accessTokenFactory,
			logger: LogLevel.None,
		})
		.withAutomaticReconnect({
			nextRetryDelayInMilliseconds: (retryContext: RetryContext): number => {
				if (retryContext.retryReason?.message === "WebSocket is not in the OPEN state") return 0;
				return clamp(retryContext.previousRetryCount * 3000, 0, 20 * 1000);
			},
		})
		.build();
}
